// removed by extract-text-webpack-plugin
module.exports = {"wrapper-modal":"magazines_2hxuu","wrapper-modal__content-close":"magazines_3yYtq","wrapper-modal__options":"magazines_8hTfT","alert-enter":"magazines_-AcBf","alert-enter-active":"magazines_286dP","alert-exit":"magazines_LGVHy","alert-exit-active":"magazines_FtbEC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/styles.scss
// module id = 1014
// module chunks = 1